import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../store";

const state = (state: RootState) => state.chatbot;

const selectAllChatbots = createSelector(state, (state) => state.bots || []);

export const chatbotSliceSelectors = {
  selectAllChatbots,
};
